module.exports = __webpack_public_path__ + "img/356.a43cc484.png";